import {
  CLEAN_ENERGY_AWARD_ELIGIBLE_SET,
  CLEAN_ENERGY_AWARD_TIERS
} from '../data/awards.js';
import { PLANT_BY_ID } from '../data/plants.js';
import { countDistinctFamiliesBuilt } from './resilienceAward.js';

export function isCleanEnergyAwardEligiblePlant(plantId) {
  return CLEAN_ENERGY_AWARD_ELIGIBLE_SET.has(plantId);
}

export function computeCleanEnergyShare({
  eligibleCleanMWh,
  totalPostDisasterMWh
}) {
  if (!Number.isFinite(eligibleCleanMWh)) return 0;
  if (!Number.isFinite(totalPostDisasterMWh)) return 0;
  if (totalPostDisasterMWh <= 0) return 0;
  return eligibleCleanMWh / totalPostDisasterMWh;
}

export function cleanEnergyAwardTier({ cleanShare, variableCleanShare = 0 }) {
  if (!Number.isFinite(cleanShare) || cleanShare <= 0) return null;
  if (!Number.isFinite(variableCleanShare) || variableCleanShare < 0) {
    return null;
  }
  for (const tier of CLEAN_ENERGY_AWARD_TIERS) {
    if (
      cleanShare >= tier.minCleanShare &&
      variableCleanShare >= tier.minVariableCleanShare
    ) {
      return tier;
    }
  }
  return null;
}

export function cleanEnergyAwardAmount({ cleanShare, variableCleanShare = 0 }) {
  return cleanEnergyAwardTier({ cleanShare, variableCleanShare })?.bonus ?? 0;
}

export function computeCleanEnergyAward({
  eligibleCleanMWh,
  variableCleanMWh = 0,
  totalPostDisasterMWh,
  portfolio = [],
  plantsById = PLANT_BY_ID
}) {
  const cleanShare = computeCleanEnergyShare({
    eligibleCleanMWh,
    totalPostDisasterMWh
  });
  const variableCleanShare = computeCleanEnergyShare({
    eligibleCleanMWh: variableCleanMWh,
    totalPostDisasterMWh
  });
  const distinctFamiliesBuilt = countDistinctFamiliesBuilt({
    portfolio,
    plantsById
  });
  const tier = cleanEnergyAwardTier({ cleanShare, variableCleanShare });
  return {
    amount: tier ? tier.bonus : 0,
    tier,
    cleanShare,
    variableCleanShare,
    eligible: Boolean(tier),
    distinctFamiliesBuilt
  };
}
